import type { AxiosResponse } from 'axios';

export function defaultGetNameFromResponse(blob: AxiosResponse) {
  return (
    (blob.headers['content-disposition'] as string)?.match?.(
      /filename=(?:\\?")?([\w,\s-() ]+(?:\.[A-Za-z]+)?)(?:\\?")?;?/,
    )?.[1] ?? 'noFileName'
  );
}

/**
 * This function gets an URL and a file name and performs a file download.
 *
 * @param url The url to fetch
 * @param getNameFromResponse The name will be given by the 'content-disposition' prop in the headers
 */
export async function downloadUrl(
  url: string,
  getNameFromResponse?: (blob: AxiosResponse) => string,
): Promise<void>;
/**
 * This function gets an URL and a file name and performs a file download.
 *
 * @param url The url to fetch
 * @param fileName The name the file will have as default in the save dialog
 */
export async function downloadUrl(url: string, fileName: string): Promise<void>;
export async function downloadUrl(
  url: string,
  secondParameter:
    | string
    | ((blob: AxiosResponse) => string) = defaultGetNameFromResponse,
): Promise<void> {
  const blob = await (
    await import('axios')
  ).default.get(url, {
    responseType: 'blob',
  });

  const actualFileName =
    typeof secondParameter === 'string'
      ? secondParameter
      : secondParameter(blob);

  (await import('file-saver')).default.saveAs(
    new Blob([blob.data]),
    actualFileName,
  );
}
